import Box from "@mui/material/Box";
import {useMemo} from "react";
import {SxProps} from "@mui/material";

import {Header} from "~/containers/header/Header";
import {designColors} from "~/ui";

import {SimplePageLayoutColorVariant} from "../types";

export interface BmSimplePageLayoutProps {
  children: React.ReactNode;
  colorVariant?: SimplePageLayoutColorVariant;
  buttonName?: string;
  headerSx?: SxProps;
  onButtonClick?: VoidFunction;
}

export const BmSimplePageLayout: React.FC<BmSimplePageLayoutProps> = ({
  children,
  colorVariant,
  buttonName,
  headerSx,
  onButtonClick,
}) => {
  const bgColor = useMemo(() => {
    switch (colorVariant) {
      case "white":
        return designColors.white;
      case "offWhite":
        return designColors.off_white;
      default:
        return designColors.off_white;
    }
  }, [colorVariant]);

  return (
    <Box bgcolor={bgColor} minHeight="100vh" display="flex" flexDirection="column">
      <Header buttonName={buttonName} onButtonClick={onButtonClick} sx={headerSx} />
      {children}
    </Box>
  );
};
